export const ACTIVITY_CATEGORY_META = {
  Users: { label: "کاربران", color: "blue" },
  Courses: { label: "دوره‌ها", color: "purple" },
  Videos: { label: "محتوا", color: "cyan" },
  Packages: { label: "پکیج‌ها", color: "geekblue" },
  Exams: { label: "آزمون‌ها", color: "orange" },
  Questions: { label: "سوالات", color: "green" },
  ExamBanks: { label: "بانک آزمون", color: "lime" },
  RBAC: { label: "نقش‌ها", color: "magenta" },
  Authentication: { label: "احراز هویت", color: "volcano" },
  Backups: { label: "پشتیبان پایگاه داده", color: "gold" },
};

export const getCategoryMeta = (category) =>
  ACTIVITY_CATEGORY_META[category] || {
    label: category || "نامشخص",
    color: "default",
  };
